import { render, staticRenderFns } from "./wanchengduPieChart2.vue?vue&type=template&id=11b9de4b"
import script from "./wanchengduPieChart2.vue?vue&type=script&lang=js"
export * from "./wanchengduPieChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports